


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { Schedule } from '@/types/schedule'
import CalendarItem from './CalendarItem.vue'
import { DateString } from '@/types/utils'
import dayjs from 'dayjs'

@Component({
  components: { CalendarItem }
})
export default class CalendarCell extends Vue {
  readonly MAX_SCHEDULE_NUM = 3
  @Prop({ default: '' })
  date!: DateString

  @Prop({ default: '2020-01-01' })
  today!: DateString

  @Prop({ default: [] })
  schedules!: Schedule[]

  @Prop({ default: false })
  highlight!: boolean

  get hasMoreSchedules() {
    return this.schedules.length > this.MAX_SCHEDULE_NUM
  }

  get reducedSchedules() {
    return this.schedules.slice(0, this.MAX_SCHEDULE_NUM)
  }

  get isDummyDay() {
    return !this.date
  }

  get displayDate() {
    return dayjs(this.date).format('D')
  }
}
